import React, { Fragment } from 'react';
import { List, ListItem, Typography } from '@mui/material';

import { FieldErrorProps } from '../../interfaces';
import { NotificationsButtonContext } from './notifications-button.context';

interface NotificationsListProps<TFieldErrorProps extends FieldErrorProps = FieldErrorProps> {
  properties: Record<string, TFieldErrorProps>;
  onClickError: (error: TFieldErrorProps & { inputName: string }) => void;
}

export function NotificationsList({
  properties,
  onClickError
}: NotificationsListProps): JSX.Element {
  const { setShowNotifications } = React.useContext(NotificationsButtonContext);

  if (Object.keys(properties).length == 0) {
    return <Fragment></Fragment>;
  }

  return (
    <List component='div' disablePadding sx={{ pl: 2 }}>
      {Object.entries(properties).map(([propertyName, field]) => (
        <ListItem
          key={propertyName}
          onClick={(): void => {
            setShowNotifications(false);
            onClickError({ ...field, inputName: propertyName });
          }}
          sx={{
            pt: 0,
            pb: 0,
            '&:hover': { backgroundColor: '#f5f5f5', cursor: 'pointer' }
          }}
        >
          <Typography
            variant='caption'
            sx={{
              padding: (theme): string => `${theme.spacing(0.3)} 0`,
              '& b': { mr: 1 }
            }}
          >
            <b>{field.label}</b>{' '}
            {field.errors.map((error) => {
              if (field.errors.length > 1) return <p key={error}>{error}</p>;
              return error;
            })}
          </Typography>
        </ListItem>
      ))}
    </List>
  );
}
